module.exports = __webpack_public_path__ + "img/four.4cafcf72.png";